import { render } from "./Accounts.vue?vue&type=template&id=66afc36d"
import script from "./Accounts.vue?vue&type=script&lang=js"
export * from "./Accounts.vue?vue&type=script&lang=js"

import "./Accounts.vue?vue&type=style&index=0&id=66afc36d&lang=css"
script.render = render

export default script